<template>
  <div class="heim-input">
    <label><span class="label">{{label}}</span>
    <textarea
      class="paper-input"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :required="required"></textarea>
      <!-- <textarea
        class="paper-input"
        :name="name"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"><textarea> -->
    </label>
  </div>
</template>

<script>
export default {
  name: "heim-textarea",
  props: {
    label: String,
    placeholder: String,
    name: String,
    required: String,
    value: {
      default: ""
    }
  },
  computed: {
    input() {
      return this.$el.querySelector("input");
    }
  }
};
</script>

<style scoped>
.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
textarea.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  min-height: 4em;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 1.1em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
textarea.paper-input:hover,
textarea.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  .heim-input {
    max-width: 32em;
  }
}
</style>
